module.exports = __webpack_public_path__ + "01_glasses.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/01_glasses.png
// module id = pIVX
// module chunks = 0